module.exports = "/fonts/Font-Awesome-5-Free-Solid-900.otf?d41d8cd98f00b204e9800998ecf8427e";